import React, { SVGProps } from 'react'

/** Feature-local "hide" glyph for the reveal toggle (matches the design prototype). */
const SvgEyeOff = (props: SVGProps<SVGSVGElement>): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    viewBox="0 0 20 20"
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <path
      stroke={props.stroke || 'currentColor'}
      strokeWidth={1.5}
      strokeLinecap="round"
      d="M2 2l16 16M8 4.2A8.7 8.7 0 0 1 10 4c5.5 0 9 6 9 6a15 15 0 0 1-2.4 2.9M5.5 5.6A15 15 0 0 0 1 10s3.5 6 9 6a8.6 8.6 0 0 0 3-.5"
    />
  </svg>
)
export default SvgEyeOff
